<template>
    <div id="app" @click="outsideClick">
        <div
            :class="[
                showMessageBar ? 'active' : '',
                'page__head__message',
                messageType,
            ]"
            v-cloak
        >
            <p
                v-for="message in messages"
                v-html="message"
                data-cy="flash-message"
            ></p>
            <button class="button-close" @click="closeMessage">
                <img src="/img/ui/icon-close.svg" alt="Close" width="14" height="14">
            </button>
        </div>
        <header
            ref="pageHead"
            class="page__head content">
            <template>
                <a href="/" class="page__head__logo">
                    <img
                        src="/img/logo-dyadey-main.svg"
                        alt="Dyadey"
                        width="139"
                        height="29"
                    >
                </a>
            </template>
            <template v-if="user !== false">
                <div class="page__head__links">
                    <a
                        href="#"
                        @click.prevent="home"
                        :class="homeActive ? 'current' : ''"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                            <path d="M12.75 17.2518C12.75 16.868 12.9263 16.5054 13.2282 16.2685L19.2282 11.5592C19.6813 11.2036 20.3187 11.2036 20.7718 11.5592L26.7718 16.2685C27.0737 16.5054 27.25 16.868 27.25 17.2518V26C27.25 26.6904 26.6904 27.25 26 27.25H24C23.3096 27.25 22.75 26.6904 22.75 26V23C22.75 22.0335 21.9665 21.25 21 21.25H19C18.0335 21.25 17.25 22.0335 17.25 23V26C17.25 26.6904 16.6904 27.25 16 27.25H14C13.3096 27.25 12.75 26.6904 12.75 26V17.2518Z" stroke="black" stroke-width="1.5" />
                        </svg>
                    </a>
                    <a
                        href="#"
                        class="notification active"
                        data-tour-mobile="notifications"
                        @click.prevent="toggleNotificationMenu"
                    >
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                            <path d="M22.9669 28.5176C22.7071 28.9682 22.3332 29.3425 21.8829 29.6027C21.4325 29.8629 20.9215 29.9999 20.4014 29.9999C19.8813 29.9999 19.3703 29.8629 18.92 29.6027C18.4696 29.3425 18.0957 28.9682 17.8359 28.5176" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M28.6899 25.1511H12C12.8815 23.3611 13.284 21.3731 13.1683 19.3811L13.0729 17.7979C12.9483 16.1603 13.2783 14.52 14.0266 13.058C15.3475 10.6022 17.6889 9 20.3211 9C22.9534 9 25.2947 10.6022 26.6156 13.058C27.3639 14.52 27.694 16.1603 27.5693 17.7979L27.4787 19.3334C27.3593 21.3404 27.7601 23.3444 28.6422 25.1511H28.6899Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>
                    <a
                        href="#"
                        @click.prevent="explore"
                        :class="exploreActive ? 'current' : ''"
                    >
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                            <circle cx="20" cy="20" r="10.25" stroke="black" stroke-width="1.5"/>
                            <path d="M14.0125 14.3479C13.905 14.133 14.133 13.905 14.3479 14.0125L22.0331 17.8551C22.0815 17.8793 22.1207 17.9185 22.1449 17.9669L25.9875 25.6521C26.095 25.867 25.867 26.095 25.6521 25.9875L17.9669 22.1449C17.9185 22.1207 17.8793 22.0815 17.8551 22.0331L14.0125 14.3479Z" stroke="black" stroke-width="1.5" />
                            <path d="M18 22L22 18" stroke="black" stroke-width="1.5" />
                        </svg>
                    </a>
                    <a href="#">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                            <circle cx="17.8571" cy="17.8571" r="6.10714" stroke="black" stroke-width="1.5"/>
                            <path d="M22.4277 22.4287L26.9992 27.0001" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>
                    <a :href="'/post/create' + (
                        typeof $root.community != 'undefined' && typeof $root.community.url != 'undefined'
                            ? '/' + $root.community.url
                            : '')"
                    >
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                            <path d="M20 12V28" stroke="black" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M28 20L12 20" stroke="black" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </a>
                    <a
                        :href="'/u/' + $root.user.username"
                        :class="['page__head__avatar', $route.path === '/settings' ? 'current' : '']"
                    >
                        <img
                            :src="$root.user.avatar"
                            width="40"
                            height="40"
                            alt=""
                        >
                    </a>
                    <!--                <a class="c-page__head__search" href="/search" data-tour-desktop="search">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18"
                            height="18" viewBox="0 0 18 18">
                            <defs>
                                <path id="icon-search-a"
                                    d="M13.6832048,12.7825544 L18.8140029,17.9133355 C19.0621641,18.1627673 19.0621641,18.5645055 18.8130114,18.8149236 C18.6920016,18.9346982 18.5305884,19 18.3636965,19 C18.1961705,19 18.0343977,18.9342171 17.9133902,18.8132099 L12.7826526,13.6824893 C11.4984497,14.7599348 9.88590202,15.3636364 8.18184472,15.3636364 C4.22175179,15.3636364 1,12.1418952 1,8.18181818 C1,4.22174116 4.22175179,1 8.18184472,1 C12.1419377,1 15.3636894,4.22174116 15.3636894,8.18181818 C15.3636894,9.88562244 14.7601512,11.498168 13.6832048,12.7825544 Z M8.18184472,14.0909091 C11.4399574,14.0909091 14.0909523,11.439923 14.0909523,8.18181818 C14.0909523,4.92371339 11.4399574,2.27272727 8.18184472,2.27272727 C4.92373202,2.27272727 2.27273715,4.92371339 2.27273715,8.18181818 C2.27273715,11.439923 4.92373202,14.0909091 8.18184472,14.0909091 Z"/>
                            </defs>
                            <g fill="none" fill-rule="evenodd" transform="translate(-1 -1)">
                                <use fill="#2B2A2F" fill-rule="nonzero" xlink:href="#icon-search-a"/>
                            </g>
                        </svg>
                    </a>-->
                    <!--                <div class="c-page-head__links">
                        <template v-if="user === false">
                            <div class="c-page__head-out u-flex u-flex-align-center">
                                <a href="#" class="c-page-head__notifications" @click.prevent="showMemberPanel">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="14" height="18" viewBox="0 0 14 18">
                                        <defs>
                                            <path id="icon-notifications-a"
                                                d="M10.9408147,2.07306861 C12.9850781,2.39677542 14.7745599,3.80853551 14.7745599,6.55671084 L14.7745599,10.8139684 C14.7745599,11.4111298 14.8985283,11.6743135 15.2792089,12.055282 C15.332642,12.1087555 15.5512144,12.3194872 15.6015356,12.3692459 C15.746255,12.5123475 15.8649678,12.6392255 15.9808403,12.7787207 C16.3437931,13.215668 16.6282081,13.7243741 16.8536131,14.3941619 C17.0148386,14.8732678 17.0550565,15.4471784 16.9157118,15.9187372 C16.7185543,16.585941 16.1864208,17 15.397761,17 L12.9413158,17 C12.6631767,18.1583733 11.4360169,19 10.0003031,19 C8.56448559,19 7.33737574,18.1584787 7.05927533,17 L4.60284508,17 C3.81418526,17 3.2820518,16.585941 3.08489434,15.9187372 C2.94554962,15.4471784 2.98576751,14.8732678 3.14699571,14.394154 C3.37239797,13.7243741 3.65681304,13.215668 4.01976579,12.7787207 C4.13563829,12.6392255 4.25435116,12.5123475 4.39907048,12.3692459 C4.44939173,12.3194872 4.66796414,12.1087555 4.72139719,12.055282 C5.10207783,11.6743135 5.22604621,11.4111298 5.22604621,10.8139684 L5.22604621,6.55671084 C5.22604621,3.80044373 7.02608148,2.38847338 9.07785546,2.07023751 C9.0966344,1.99696299 9.11869571,1.92041544 9.14434027,1.84291957 C9.31317173,1.332724 9.54767531,1 10.0181602,1 C10.4911231,1 10.7240243,1.33419846 10.8774056,1.83317064 C10.9026433,1.91527242 10.9236075,1.99617385 10.9408147,2.07306861 Z M11.8835661,17 L8.11700041,17 C8.39075189,17.5708973 9.11819884,18 10.0003031,18 C10.8822924,18 11.6097684,17.5708376 11.8835661,17 Z M15.397761,16 C15.7351288,16 15.8829388,15.8849874 15.9567054,15.6353526 C16.0319969,15.3805574 16.0061033,15.0110549 15.9058405,14.7131088 C15.7198295,14.1603797 15.4960398,13.7601083 15.211607,13.4176887 C15.1190978,13.3063199 15.0217051,13.2022284 14.8984144,13.080316 C14.8549652,13.0373525 14.6334587,12.8237918 14.5718349,12.7621215 C14.0143277,12.2041926 13.7745599,11.6951678 13.7745599,10.8139684 L13.7745599,6.55671084 C13.7745599,5.13986739 13.2012416,4.2003169 12.2007958,3.61303684 C11.4960748,3.19935262 10.6165576,3 10.0003031,3 C9.38404846,3 8.50453134,3.19935262 7.79981028,3.61303684 C6.79936451,4.2003169 6.22604621,5.13986739 6.22604621,6.55671084 L6.22604621,10.8139684 C6.22604621,11.6951678 5.98627839,12.2041926 5.4287712,12.7621215 C5.36714742,12.8237918 5.1456409,13.0373525 5.10219169,13.080316 C4.97890105,13.2022284 4.88150827,13.3063199 4.7889991,13.4176887 C4.50456632,13.7601083 4.28077659,14.1603797 4.09476829,14.7131009 C3.9945028,15.0110549 3.96860919,15.3805574 4.0439007,15.6353526 C4.1176673,15.8849874 4.26547729,16 4.60284508,16 L15.397761,16 Z"/>
                                        </defs>
                                        <g fill="none" fill-rule="evenodd" transform="translate(-3 -1)">
                                            <use fill="#231F20" xlink:href="#icon-notifications-a"/>
                                        </g>
                                    </svg>
                                </a>
                                <a href="#" class="c-page-head__avatar js-join-convo__cta" @click.prevent="showMemberPanel" data-cy="avatar-login-header">
                                    <img src="/img/avatar-default.svg" alt="Default Avatar" width="30" height="30">
                                </a>
                            </div>
                        </template>
                        <template v-else>
                            <div class="c-page__head-in">
                                <a href="#" @click.prevent="toggleNotifications" class="c-page-head__notifications" data-tour-desktop="notifications">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="14" height="18" viewBox="0 0 14 18">
                                        <defs>
                                            <path id="icon-notifications-a" d="M10.9408147,2.07306861 C12.9850781,2.39677542 14.7745599,3.80853551 14.7745599,6.55671084 L14.7745599,10.8139684 C14.7745599,11.4111298 14.8985283,11.6743135 15.2792089,12.055282 C15.332642,12.1087555 15.5512144,12.3194872 15.6015356,12.3692459 C15.746255,12.5123475 15.8649678,12.6392255 15.9808403,12.7787207 C16.3437931,13.215668 16.6282081,13.7243741 16.8536131,14.3941619 C17.0148386,14.8732678 17.0550565,15.4471784 16.9157118,15.9187372 C16.7185543,16.585941 16.1864208,17 15.397761,17 L12.9413158,17 C12.6631767,18.1583733 11.4360169,19 10.0003031,19 C8.56448559,19 7.33737574,18.1584787 7.05927533,17 L4.60284508,17 C3.81418526,17 3.2820518,16.585941 3.08489434,15.9187372 C2.94554962,15.4471784 2.98576751,14.8732678 3.14699571,14.394154 C3.37239797,13.7243741 3.65681304,13.215668 4.01976579,12.7787207 C4.13563829,12.6392255 4.25435116,12.5123475 4.39907048,12.3692459 C4.44939173,12.3194872 4.66796414,12.1087555 4.72139719,12.055282 C5.10207783,11.6743135 5.22604621,11.4111298 5.22604621,10.8139684 L5.22604621,6.55671084 C5.22604621,3.80044373 7.02608148,2.38847338 9.07785546,2.07023751 C9.0966344,1.99696299 9.11869571,1.92041544 9.14434027,1.84291957 C9.31317173,1.332724 9.54767531,1 10.0181602,1 C10.4911231,1 10.7240243,1.33419846 10.8774056,1.83317064 C10.9026433,1.91527242 10.9236075,1.99617385 10.9408147,2.07306861 Z M11.8835661,17 L8.11700041,17 C8.39075189,17.5708973 9.11819884,18 10.0003031,18 C10.8822924,18 11.6097684,17.5708376 11.8835661,17 Z M15.397761,16 C15.7351288,16 15.8829388,15.8849874 15.9567054,15.6353526 C16.0319969,15.3805574 16.0061033,15.0110549 15.9058405,14.7131088 C15.7198295,14.1603797 15.4960398,13.7601083 15.211607,13.4176887 C15.1190978,13.3063199 15.0217051,13.2022284 14.8984144,13.080316 C14.8549652,13.0373525 14.6334587,12.8237918 14.5718349,12.7621215 C14.0143277,12.2041926 13.7745599,11.6951678 13.7745599,10.8139684 L13.7745599,6.55671084 C13.7745599,5.13986739 13.2012416,4.2003169 12.2007958,3.61303684 C11.4960748,3.19935262 10.6165576,3 10.0003031,3 C9.38404846,3 8.50453134,3.19935262 7.79981028,3.61303684 C6.79936451,4.2003169 6.22604621,5.13986739 6.22604621,6.55671084 L6.22604621,10.8139684 C6.22604621,11.6951678 5.98627839,12.2041926 5.4287712,12.7621215 C5.36714742,12.8237918 5.1456409,13.0373525 5.10219169,13.080316 C4.97890105,13.2022284 4.88150827,13.3063199 4.7889991,13.4176887 C4.50456632,13.7601083 4.28077659,14.1603797 4.09476829,14.7131009 C3.9945028,15.0110549 3.96860919,15.3805574 4.0439007,15.6353526 C4.1176673,15.8849874 4.26547729,16 4.60284508,16 L15.397761,16 Z"/>
                                        </defs>
                                        <g fill="none" fill-rule="evenodd" transform="translate(-3 -1)">
                                            <use :fill="notificationsUnread ? '#DB2848' : '#231F20'" xlink:href="#icon-notifications-a"/>
                                        </g>
                                    </svg>
                                </a>
                                <a :href="'/u/' + $root.user.username" class="u-flex u-flex-align-center" data-tour-desktop="profile" data-cy="profile-link">
                                    <div class="c-avatar"><img :src="$simpleStore.cloudinaryUrl(30, 30, $root.user.avatar, $root)" :alt="$root.user.firstName + '\'s Avatar'" width="30" height="30"></div>
                                </a>
                            </div>
                        </template>
                    </div>-->
                </div>
            </template>
            <template v-else>
                <div
                    class="c-page-head__account-links logged-out"
                >
                    <a href="/search" data-tour-mobile="search">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                            <circle cx="17.8571" cy="17.8571" r="6.10714" stroke="black" stroke-width="1.5" />
                            <path d="M22.4277 22.4287L26.9992 27.0001" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>
                    <a href="#" @click.prevent="showMemberPanel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <circle cx="20" cy="20" r="20" fill="#DB2848"/>
                            <path d="M13 28C13.4126 26.3157 14.3578 24.8162 15.69 23.7324C17.0223 22.6486 18.6676 22.0405 20.3727 22.002C22.0778 21.9634 23.748 22.4964 25.1262 23.5188C26.5045 24.5413 27.5142 25.9966 28 27.6605" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M20.3806 19H19.6153C18.6565 19 17.7369 18.6125 17.0589 17.9227C16.3809 17.233 16 16.2974 16 15.3219V14.9853C16 13.9283 16.4127 12.9146 17.1473 12.1673C17.882 11.4199 18.8783 11 19.9173 11C20.4536 10.9994 20.9847 11.1065 21.4803 11.3151C21.9759 11.5236 22.4262 11.8295 22.8054 12.2153C23.1846 12.6011 23.4853 13.0593 23.6903 13.5634C23.8953 14.0676 24.0005 14.608 24 15.1536V15.3219C24 16.2974 23.6191 17.233 22.9411 17.9227C22.2631 18.6125 21.3435 19 20.3847 19H20.3806Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                </div>
            </template>
        </header>
        <div class="page__content">
            <router-view name="index"></router-view>
        </div>
        <footer class="page__foot">
            <ul>
                <li v-if="user !== false">
                    <a
                        href="#"
                        @click.prevent="home"
                        :class="homeActive ? 'current' : ''"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                            <path d="M12.75 17.2518C12.75 16.868 12.9263 16.5054 13.2282 16.2685L19.2282 11.5592C19.6813 11.2036 20.3187 11.2036 20.7718 11.5592L26.7718 16.2685C27.0737 16.5054 27.25 16.868 27.25 17.2518V26C27.25 26.6904 26.6904 27.25 26 27.25H24C23.3096 27.25 22.75 26.6904 22.75 26V23C22.75 22.0335 21.9665 21.25 21 21.25H19C18.0335 21.25 17.25 22.0335 17.25 23V26C17.25 26.6904 16.6904 27.25 16 27.25H14C13.3096 27.25 12.75 26.6904 12.75 26V17.2518Z" stroke="black" stroke-width="1.5" />
                        </svg>
                    </a>
                </li>
                <li v-if="user !== false">
                    <a
                        href="#"
                        @click.prevent="explore"
                        :class="exploreActive ? 'current' : ''"
                        data-tour-mobile="explore">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                            <circle cx="20" cy="20" r="10.25" stroke="black" stroke-width="1.5"/>
                            <path d="M14.0125 14.3479C13.905 14.133 14.133 13.905 14.3479 14.0125L22.0331 17.8551C22.0815 17.8793 22.1207 17.9185 22.1449 17.9669L25.9875 25.6521C26.095 25.867 25.867 26.095 25.6521 25.9875L17.9669 22.1449C17.9185 22.1207 17.8793 22.0815 17.8551 22.0331L14.0125 14.3479Z" stroke="black" stroke-width="1.5" />
                            <path d="M18 22L22 18" stroke="black" stroke-width="1.5" />
                        </svg>
                    </a>
                </li>
                <li v-if="user !== false">
                    <template v-if="publishButton === false">
                        <a :href="'/post/create' + (
                            typeof $root.community != 'undefined' && typeof $root.community.url !== 'undefined'
                                ? '/' + $root.community.url
                                : '')"
                           ref="mobileCreate"
                        >
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                                <path d="M20 12V28" stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M28 20L12 20" stroke="black" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                        </a>
                    </template>
                    <template v-else>
                        <a
                            href="#"
                            :class="['ugc__publish-bottom', publishMobileDisabled ? 'publish-disabled' : '']"
                            @click.prevent="publishConfirmation"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                <path d="M21 1L1 9.23513L9.23513 12.7645M21 1L12.7649 21L9.23548 12.7649M21 1L9.23548 12.7645" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Post</p>
                        </a>
                    </template>
                </li>
                <li>
                    <template v-if="user === false">
                        <a href="#" @click.prevent="showMemberPanel">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                                <circle cx="17.8571" cy="17.8571" r="6.10714" stroke="black" stroke-width="1.5" />
                                <path d="M22.4277 22.4287L26.9992 27.0001" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </a>
                    </template>
                    <template v-else>
                        <a href="/search" data-tour-mobile="search">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="20" r="20" fill="#F3F3F3" />
                                <circle cx="17.8571" cy="17.8571" r="6.10714" stroke="black" stroke-width="1.5" />
                                <path d="M22.4277 22.4287L26.9992 27.0001" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </a>
                    </template>
                </li>
                <li class="page__foot__avatar">
                    <template v-if="user === false">
                        <a
                            href="#"
                            class="js-join-convo__cta"
                            @click.prevent="showMemberPanel"
                            data-cy="avatar-login-footer"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <circle cx="20" cy="20" r="20" fill="#DB2848"/>
                                <path d="M13 28C13.4126 26.3157 14.3578 24.8162 15.69 23.7324C17.0223 22.6486 18.6676 22.0405 20.3727 22.002C22.0778 21.9634 23.748 22.4964 25.1262 23.5188C26.5045 24.5413 27.5142 25.9966 28 27.6605" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M20.3806 19H19.6153C18.6565 19 17.7369 18.6125 17.0589 17.9227C16.3809 17.233 16 16.2974 16 15.3219V14.9853C16 13.9283 16.4127 12.9146 17.1473 12.1673C17.882 11.4199 18.8783 11 19.9173 11C20.4536 10.9994 20.9847 11.1065 21.4803 11.3151C21.9759 11.5236 22.4262 11.8295 22.8054 12.2153C23.1846 12.6011 23.4853 13.0593 23.6903 13.5634C23.8953 14.0676 24.0005 14.608 24 15.1536V15.3219C24 16.2974 23.6191 17.233 22.9411 17.9227C22.2631 18.6125 21.3435 19 20.3847 19H20.3806Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </template>
                    <template v-else>
                        <a
                            :href="'/u/' + $root.user.username"
                            :class="/^\/(settings|u\/)/.test($route.path) === true ? 'current' : ''"
                            data-tour-mobile="profile"
                            :data-test="$router.name"
                        >
                            <!-- <div class="c-avatar">
                                <img
                                    :src="
                                        $simpleStore.cloudinaryUrl(
                                            26,
                                            26,
                                            $root.user.avatar,
                                            $root
                                        )
                                    "
                                    :alt="$root.user.firstName + '\'s Avatar'"
                                    width="26"
                                    height="26"
                                />
                            </div> -->
                            <img
                                src="/img2.0/avatar-example.png"
                                width="40"
                                height="40"
                                alt=""
                            />
                        </a>
                    </template>
                </li>
                <div class="ugc__publish-notification">
                    <p>
                        Please add a title and text to your article to post it
                    </p>
                </div>
            </ul>
        </footer>

        <!-- TODO: 13/7/24 add notifications here -->
        <Menu
            :show-menu="showNotificationMenu"
            scroll-class="menu__content--scroll"
            close-event="bus-notifications-menu-close"
            start-height-class="menu__height-500"
        >
            <NotificationsModal></NotificationsModal>
        </Menu>

        <div
            v-if="(user === false || cookiePanel === true)"
            data-cy="panel-join"
            :class="[
                showCookiesPanel ? 'cookie-consent' : '',
            ]"
        >
            <router-view name="userPanels" @mounted="userPanelsMounted"></router-view>
        </div>
        <router-view name="invitesPanel"></router-view>
        <!--        <div :class="[showCookieBar ? 'active' : '', 'c-page-foot__cookies']" v-cloak>
            <p>To help personalise content, tailor and measure ads and provide a safer experience, we use cookies. By clicking on or navigating the site, you agree to allow us to collect information on and off Dyadey through cookies. Learn more, including about available controls: <a href="/cookies">Cookies Policy</a>.</p>
            <button class="button-close" @click="cookieClose"><img src="/img/ui/icon-close.svg" alt="Close"></button>
        </div>-->
        <router-view name="tour"></router-view>
    </div>
</template>

<script>
import Menu from "../components/menu/Menu.vue";
import NotificationsModal from "./NotificationsModal";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import Vue from "vue";

export default {
    components: {
        Menu,
        NotificationsModal
    },
    data() {
        return {
            admin: false,
            hash: null,
            user: this.$root.user,
            cookiePanel: false,
            exploreActive: false,
            homeActive: false,
            lastScrollPosition: 0,
            lastScrollDownPosition: 0,
            lastScrollUpPosition: 0,
            logoWidth: 139,
            showMessageBar: this.$root.showMessageBar,
            messageType:
                typeof this.$root.messageType != 'undefined'
                    ? this.$root.messageType
                    : null,
            messages:
                typeof this.$root.messages != 'undefined'
                    ? this.$root.messages
                    : null,
            scrolledToBottom: false,
            success: false,
            notificationsUnread: this.$root.notificationsUnread,
            showContextMenu: this.$root.showContextMenu,
            showCookiesPanel: false,
            enableMobilePublish: false,
            publishButton: false,
            showBackLink: true,
            showNotificationMenu: false,
            publishMobileDisabled: false
        };
    },
    created() {
        // only add Bugsnag in production environment
        if (PRODUCTION === true) {
            Bugsnag.start({
                apiKey: VUE_CONFIG.BUGSNAG_API_KEY,
                appVersion: VUE_CONFIG.APP_VERSION,
                releaseStage: 'production',
                plugins: [new BugsnagPluginVue(Vue)],
                onError: (event) => {
                    if (this.user) {
                        event.setUser(
                            this.user.id,
                            this.user.email,
                            this.user.firstName + ' ' + this.user.surname
                        );
                    }
                },
            });
        }
        let settings = this.$cookies.get('cookieSettings');
        if (settings == null) {
            // by setting cookiePanel = true then userPanelsMounted() method will be called
            // allowing us to call this.$simpleStore.showCookiePanel() method in userPanelsMounted() below
            this.cookiePanel = true;
        }


        if (window.location.pathname === '/cookies') {
            this.cookiePanel = true;
        }

        this.$root.$on('fade-page', () => {
            this.$root.$el.classList.add('faded-page');
        });
        this.$root.$on('unfade-page', () => {
            if (this.$root.$el.classList.contains('faded-page') === false) {
                return;
            }
            this.$root.$el.classList.remove('faded-page');
            this.$root.$el.classList.add('unfading-page');
            setTimeout(() => {
                this.$root.$el.classList.remove('unfading-page');
            }, 350);
        });
        this.$root.$on('show-cookie-panel-bleed', () => {
            this.showCookiesPanel = true;
        });
        this.$root.$on('bus-nav-explore', () => {
            this.exploreActive = true;
            this.homeActive = false;
        });
        this.$root.$on('bus-nav-feed', () => {
            this.homeActive = true;
            this.exploreActive = false;
        });
        this.$root.$on('bus-publish-mobile-disabled', (toggle, debug) => {
            this.publishMobileDisabled = toggle;
            console.log('bus-publish-mobile-disabled', toggle, 'debug', debug);
        });
        this.$root.$on('bus-notifications-menu-close', this.closeMenu);

        // allow for has links e.g. #join in message bar
        window.addEventListener('hashchange', this.hashActions, false);
        this.setAdmin();
        // set device pixel ratio variables
        this.$root.$dpr = Math.floor(window.devicePixelRatio).toFixed(1);
        // do not show back link if first visit
        if (document.referrer.indexOf(window.location.hostname) === -1) {
            this.showBackLink = false;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll);
        let logoSizesSmall = ['xs', 's', 'm'];
        if (logoSizesSmall.includes(this.$simpleStore.getMediaSize())) {
            this.logoWidth = 110;
        }
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    },
    updated() {
        if (this.hash == null) {
            this.hash = this.$simpleStore.getHash();
            if (this.hash === 'invalid') {
                this.showMessageBar = false;
                this.showLoginPanelInvalid();
            }
        }
    },
    watch: {
        $route (to, from) {
            if (to.path === '/explore') {
                this.exploreActive = true;
                this.homeActive = false;
            }
            if (to.path === '/') {
                this.homeActive = true;
                this.exploreActive = false;
            }
        }
    },
    methods: {
        userPanelsMounted() {
            if (this.cookiePanel === true) {
                this.$simpleStore.showCookiePanel(this);
            }
            this.hashActions();
        },
        closeMenu() {
            this.showNotificationMenu = false;
        },
        toggleNotificationMenu() {
            this.showNotificationMenu = !this.showNotificationMenu;
        },
        applyDPR(image) {
            return image.replace(',dpr_1.0', ',dpr_' + this.$root.$dpr);
        },
        publishConfirmation() {
            if (this.enableMobilePublish) {
                this.$root.$emit('publish-confirmation');
            }
        },
        setAdmin() {
            if (
                typeof this.$root.user != 'undefined' &&
                typeof this.$root.user.jwt != 'undefined'
            ) {
                this.$http
                    .post('/api/v1/user/role', { jwt: this.$root.user.jwt })
                    .then(
                        (response) => {
                            if (
                                typeof response.data.role != 'undefined' &&
                                response.data.role === 'admin'
                            ) {
                                this.admin = true;
                                return;
                            }
                            this.admin = false;
                        },
                        (response) => {
                            console.log('Errored:');
                            console.log(response);
                        }
                    );
            } else {
                this.admin = false;
            }
        },
        isModalDetected() {
            // modals should have a width of 100vw and a height of 100vh, so we can detect when a modal is open
            const modalClasses = ['menu', 'modal-window', 'side-panel', 'action-panel'];
            for (const modalClass of modalClasses) {
                const modals = document.querySelectorAll(`div.${modalClass}`);
                for (const modal of modals) {
                    const rect = modal.getBoundingClientRect();
                    const isFullWidth = Math.floor(rect.width) === window.innerWidth;
                    const isFullHeight = Math.floor(rect.height) === window.innerHeight;
                    const isPositionedAtTopLeft = rect.top === 0 && rect.left === 0;
                    if (isFullWidth && isFullHeight && isPositionedAtTopLeft) {
                        return true;
                    }
                }
            }
            return false;
        },
        outsideClick(event) {
            if (this.$route.name === 'post') {
                let postClick = false;
                let path = event.composedPath();
                for (let i = 0; i < path.length; i++) {
                    if (typeof path[i].classList == 'undefined' || path[i].classList.length === 0) {
                        continue;
                    }
                    if (
                        path[i].classList.contains('post__click') === true ||
                        path[i].classList.contains('menu') ||
                        path[i].classList.contains('page__head__links')
                    ) {
                        postClick = true;
                        break;
                    }
                }
                if (postClick === false) {
                    window.location = '/' + this.$root.community.url;
                }
            }
            if (this.isModalDetected() === false) {
                return;
            }
            // if modal-window is open and clicked off then target with be .modal-window which is container
            if (event.target === document.getElementsByClassName('modal-window')[0]) {
                this.$root.$emit('bus-community-leave-show-event');
            }
            // if menu is open and clicked off then target with be .menu which is container
            // all registered menu events should end with -menu-close then we can track them using the
            // eventLogger.js component
            if (event.target === document.getElementsByClassName('menu')[0]) {
                const registeredEvents = this.$root.$getRegisteredEvents();
                const closeMenuEvents = registeredEvents.filter(event => event.endsWith('-menu-close'));
                closeMenuEvents.forEach(event => {
                    let close = true;
                    this.$root.$emit(event, close);
                });
            }
            if (event.target === document.getElementsByClassName('modal-window')[0]) {
                const registeredEvents = this.$root.$getRegisteredEvents();
                const closeModalEvents = registeredEvents.filter(event => event.endsWith('-modal-close'));
                closeModalEvents.forEach(event => {
                    let close = true;
                    this.$root.$emit(event, close);
                });
            }





            // if side-panel is open and clicked off then target with be .side-panel which is container
            if (event.target === document.getElementsByClassName('side-panel')[0]) {
                this.$root.$emit('bus-close-side-panel');
            }


            // if action-panel is open and clicked off then target with be .action-panel which is container
            if (event.target === document.getElementsByClassName('action-panel')[0]) {
                this.$root.$emit('bus-close-invite-panel');
            }
        },
        closeMessage() {
            this.showMessageBar = false;
        },
        showMemberPanel() {
            let communityName = null;
            if (this.$root.community) {
                communityName = this.$root.community.name;
            }
            this.$simpleStore.showMemberPanel(this, communityName);
        },
        showLoginPanel() {
            this.$simpleStore.showLoginPanel(this);
        },
        showLoginPanelInvalid() {
            this.$simpleStore.showLoginPanel(this, true);
        },
        explore() {
            if (this.$route.path === '/explore' || this.$route.path === '/') {
                this.$root.$emit('bus-tab-explore');
                this.exploreActive = true;
                this.homeActive = false;
                history.pushState({}, '', '/explore');
            } else {
                window.location = '/explore';
            }
        },
        home() {
            if (this.$route.path === '/explore' || this.$route.path === '/') {
                this.$root.$emit('bus-tab-feed');
                this.exploreActive = false;
                this.homeActive = true;
                history.pushState({}, '', '/');
            } else {
                window.location = '/';
            }
        },
        onScroll() {
            if (this.$simpleStore.getMediaSize() === 'xl') {
                return;
            }
            const currentScrollPosition = window.scrollY || document.documentElement.scrollTop;
            // scrolling up
            if (currentScrollPosition < this.lastScrollPosition) {
                // make navigation appear on scrolling up
                document.querySelector('.page__head').style.position = 'fixed';
                document.querySelector('.page__head').style.top = '0';
                this.lastScrollUpPosition = currentScrollPosition;
            // scrolling down
            } else {
                document.querySelector('.page__head').style.position = 'absolute';
                // make navigation gradually disappear with scrolling down
                document.querySelector('.page__head').style.top = this.lastScrollUpPosition + 'px';
                this.lastScrollDownPosition = currentScrollPosition;
            }
            this.lastScrollPosition = currentScrollPosition;
        },
        hashActions() {
            // this method is called by <router-view name='userPanels' @mounted='hashActions'> above when the userPanels component has been mounted (see $emit on mounted() method of UserPanels component)
            // it is also called by window.addEventListener('hashchange', this.hashActions, false) in the created() method above
            let hash = this.$simpleStore.getHash();
            if (hash === 'join') {
                this.showMessageBar = false;
                this.showMemberPanel();
            } else if (hash === 'login') {
                this.showMessageBar = false;
                this.showLoginPanel();
            } else if (hash === 'invalid') {
                this.showMessageBar = false;
                this.showLoginPanelInvalid();
            } else if (hash.substring(0, 6) === 'resend') {
                let parts = hash.split('/');
                let encodedUserId = parts[1];
                window.location = '/rv/' + encodedUserId;
            }
        }
    },
};
</script>
